import ButtonPrimary from '../components/style-components/ButtonPrimary';
import ProductGrid from '../components/ProductGrid';
import Spinner from '../components/Spinner';
import videoFile from '../img/video.mp4';
import { useSelector, useDispatch } from 'react-redux';
import { getProducts, reset } from '../features/products/productSlice';
import { animateScroll as scroller } from 'react-scroll';
import { useTextService } from '../services/useTextService';
import { Helmet } from 'react-helmet';
import { useEffect, useMemo, useState } from 'react';

function Home() {
  const dispatch = useDispatch();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const currentLang = localStorage.getItem('lang') || 'lv';

  const { products, isLoading } = useSelector((state) => state.product);
  const { getPlainValueByTag } = useTextService();

  const categories = useMemo(() => {
    const unique = [];
    const seen = new Set();

    products.forEach((product) => {
      if (seen.has(product.category)) return;
      seen.add(product.category);
      unique.push({
        value: product.category,
        label: currentLang === 'en' ? (product.category_english || product.category) : product.category,
      });
    });

    return unique;
  }, [products, currentLang]);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, [dispatch]);
  
  useEffect(() => {
    dispatch(getProducts());
  }, [dispatch]);

  useEffect(() => {
    if (selectedCategory === 'all') return;
    const exists = categories.some((category) => category.value === selectedCategory);
    if (!exists) setSelectedCategory('all');
  }, [categories, selectedCategory]);

  const handleVeikalsClick = (e) => {
    e.preventDefault();
    
    scroller.scrollTo('veikals', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -100,
    });
  }

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div className="home-page">
      <Helmet>
        <title>Nora Spora - Sēņu Audzēšanas Komplekti</title>
        <meta name="description" content="Nora Spora piedāvā plašu klāstu sēņu audzēšanas komplektu, tostarp rozā un pelēkās austersēnes, ežu dižadatenes, gļotainās zvīņenes un drīzumā arī citas." />
        <meta name="keywords" content="nora, spora, sporas, noraspora, supersenes, supersēnes, super, sēnes, maple garden, kļavas dārzs, svaigas sēnes, Trubenieki, Eco Fungus, Austersēnes, Sēņu laboratorija Spora, baravikas, gailenes, bekas, micēlijs, micēlija tapiņas, micēlija dībeļi, rozā austersēnes, austeres, pelēkās austersēnes, zilās austersēnes, lions mane, ežu dižadatene, reiši, reishi, shitake, šitake, šitaki, dzeltenās austersēnes, zeltainās austersēnes, zelta austersēnes, dāvana, dāvanas, hobijs, ekoloģisks, bioloģisks, bio, eko, dabīgs, latvijas sēnes" />
      </Helmet>
      <div className="hero-section">
        <video 
          autoPlay 
          muted 
          loop 
          className="video-background" 
          playsInline 
          disablePictureInPicture 
          controls={false}
        >
          <source src={videoFile} type="video/mp4" />
          {/* Your browser does not support the video tag. */}
        </video>
        <div className="hero-content">
          <h1>Nora Spora</h1>
          <p className='padding-20-bottom'>{getPlainValueByTag("home-subtext")}</p>
            <ButtonPrimary text={getPlainValueByTag("home-iepirkties")} onClick={(e) => handleVeikalsClick(e)} />
        </div>
      </div>
      <div className="container-no-padding" id="veikals">
        <div className="featured-section padding-40-top">
          <div className="shop-header flex space-between align-center padding-20-bottom">
            <h2 className='light'>{getPlainValueByTag("home-audzesanas-komplekti")}</h2>
            <select
              className="basic-input shop-category-select"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="all">
                {currentLang === 'en' ? 'All categories' : 'Visas kategorijas'}
              </option>
              {categories.map((category) => (
                <option key={category.value} value={category.value}>
                  {category.label}
                </option>
              ))}
            </select>
          </div>
          <ProductGrid
            products={products}
            selectedCategory={selectedCategory}
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
